// extracted by mini-css-extract-plugin
export default {"Login":"Contact_Login__NVcav","section":"Contact_section__WmzAJ","Button":"Contact_Button__nldLi","Bottom":"Contact_Bottom__y0g6s"};